import React, {useCallback, useEffect, useState} from 'react';
import {setIsMacroMapping} from 'actions/index.js';
import ParameterKnob from 'components/knobs/ParameterKnob.js';
import {connect} from 'react-redux';
import Colors from 'components/Colors.js';

const colors = new Colors();

const MacroKnob = ({macro, parameterToMap, isMacroMapping, setIsMacroMapping, scrollContainer}) => {
    let {macroParameter, name} = macro;
    let [isMapped, setIsMapped] = useState(
        parameterToMap && macro.isParameterMapped(parameterToMap));

    useEffect(() => {
        if (parameterToMap) {
            setIsMapped(macro.isParameterMapped(parameterToMap));
        } else {
            setIsMapped(false);
        }
    }, [parameterToMap, setIsMapped]);

    const mapParameter = useCallback(() => {
        if (!isMacroMapping || !parameterToMap) {
            return;
        }

        if (!isMapped) {
            macro.addParameter(parameterToMap);
        } else {
            macro.unmapParameter(parameterToMap);
        }
        setIsMapped(!isMapped);

        // this is to force the ui to update
        // really what we want is a redux system for mapping parameters
        // to macros...
        setIsMacroMapping(false);
        setIsMacroMapping(true);
    }, [parameterToMap, setIsMapped, isMapped, isMacroMapping]);

    return (
        <div className="macro-knob">
          <div className="macro-name">
            {name}
          </div>
          <ParameterKnob
            scrollContainer={scrollContainer}
            color={colors.getColorForHash(macro.id)}
            parameter={macroParameter}/>
        {isMacroMapping ? 
         <div onClick={mapParameter} className={isMapped ? "unmap map-button" : "map-button"}>
            {isMapped ? "Unmap" : "Map"}
          </div> : ''}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        isMacroMapping: state.effects.isMacroMapping,
        parameterToMap: state.effects.isMacroMapping && state.effects.parameterToMap
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setIsMacroMapping: (x) => dispatch(setIsMacroMapping(x))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MacroKnob);
